import { jsx as _jsx } from "react/jsx-runtime";
import { upgradeProductToTrialIds } from 'self-service-api/constants/Trials'; // @ts-expect-error dependency missing types

import TrialActivationButton from 'ui-addon-upgrades/_core/trial/activation/TrialActivationButton';
// @ts-expect-error dependency missing types
import { useMultiTrialTrackingProps } from '../_core/trial/useMultiTrialTrackingProps'; // @ts-expect-error dependency missing types

import { TRIAL_STANDARD_DURATION } from '../_core/trial/constants';

const updateUpgradeData = props => {
  const {
    upgradeData: {
      app,
      screen,
      uniqueId,
      duration
    }
  } = props;
  const isScreenUrlPath = screen.split('/').length > 1;
  const source = isScreenUrlPath ? uniqueId // Special case for UMS modals (uniqueId === upgradeKey)
  : `${app}-${screen}-trial-button-${uniqueId}`;
  return Object.assign({}, props, {
    upgradeData: Object.assign({}, props.upgradeData, {
      source,
      trialId: upgradeProductToTrialIds[props.upgradeData.upgradeProduct] || null,
      duration: duration || TRIAL_STANDARD_DURATION
    })
  });
};

const UITrialActivationButton = props => {
  const {
    activeTrials,
    expiredTrials,
    isMultiTrial,
    isLoadingTrackingProps
  } = useMultiTrialTrackingProps();

  if (isLoadingTrackingProps) {
    return null;
  }

  return /*#__PURE__*/_jsx(TrialActivationButton, Object.assign({}, updateUpgradeData(props), {
    activeTrials: activeTrials,
    expiredTrials: expiredTrials,
    isMultiTrial: isMultiTrial
  }));
};

export default UITrialActivationButton;